import { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { subscribeToBookingValidationAlerts } from '@/lib/booking-validation-alert';

/**
 * Presents a booking the API refused, with the reason it gave. Mounted once at the app
 * root: every save path reports these refusals here instead of as a toast, so the reason
 * stays on screen until it is acknowledged.
 */
export function BookingValidationDialog() {
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => subscribeToBookingValidationAlerts(setMessage), []);

  return (
    <AlertDialog open={message !== null} onOpenChange={open => { if (!open) setMessage(null); }}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-destructive" aria-hidden="true" />
            Booking not allowed
          </AlertDialogTitle>
          <AlertDialogDescription>{message}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={() => setMessage(null)}>OK</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
